<template>
  <div 
    data-section-name="new_insurer"
    class="highlight-new p-4 bg-blue-50 rounded-lg border border-blue-200"
  >
    <h5 class="form-section-heading mb-4">New Insurer Information</h5>
    
    <div class="form-grid-2 gap-4">
      <FormField
        label="New Insurer Name"
        field-id="new-insurer-name"
        :error="errors?.newInsurerName"
        required
      >
        <input
          id="new-insurer-name"
          :value="modelValue?.name"
          @input="updateField('name', $event.target.value)"
          type="text"
          class="input-responsive"
          placeholder="New insurance company name"
        />
      </FormField>
      
      <FormField
        label="New Policy Number"
        field-id="new-policy-number"
        :error="errors?.newPolicyNumber"
        required
      >
        <input
          id="new-policy-number"
          :value="modelValue?.policyNumber"
          @input="updateField('policyNumber', $event.target.value)"
          type="text"
          class="input-responsive"
          placeholder="New policy number"
        />
      </FormField>
      
      <FormField
        label="New Policy Effective Date"
        field-id="new-policy-date"
        :error="errors?.newPolicyDate"
        class="md:col-span-2"
      >
        <ResponsiveDateInput
          field-id="new-policy-date"
          :model-value="modelValue?.effectiveDate"
          @update:model-value="updateField('effectiveDate', $event)"
          :min-date="today"
          :error="errors?.newPolicyDate"
          label=""
          :required="false"
          :showOptionalLabel="false"
          :showRequiredLabel="false"
          :userRole="customerType"
        />
      </FormField>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import FormField from '@/components/common/FormField.vue';
import ResponsiveDateInput from '@/components/common/ResponsiveDateInput.vue';

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({})
  },
  today: {
    type: String,
    required: true
  },
  customerType: {
    type: String,
    default: 'customer'
  },
  errors: {
    type: Object,
    default: () => ({})
  }
});

const emit = defineEmits(['update:modelValue']);

const updateField = (field, value) => {
  const updatedData = { ...props.modelValue, [field]: value };
  emit('update:modelValue', updatedData);
};
</script>

<style scoped>
.form-section-heading {
  @apply text-lg font-semibold text-gray-800 mb-4;
}

.form-grid-2 {
  @apply grid grid-cols-1 md:grid-cols-2 gap-4;
}

.input-responsive {
  @apply w-full px-3 py-2 text-base sm:text-sm;
  @apply h-10; /* Standard height */
  @apply border border-gray-300 rounded-md shadow-sm;
  @apply bg-white;
  @apply focus:outline-none focus:ring-2;
}
</style> 